module.exports = __webpack_public_path__ + "static/header-477e84a431f06c36235c87ef3ed2b3cc.svg";